module.exports = __webpack_public_path__ + "img/3029114-60-8.9aacdfed.png";